import { z } from "zod";

export type ITasksEndpointParameters = z.infer<typeof TTasksEndpointParameters>;
export const TTasksEndpointParameters = z
  .object({
    archived: z.boolean(),
    executors: z.array(z.string()),
    invoiceReceivers: z.array(z.string()),
    priority: z.number(),
    propertyIDs: z.array(z.string()),
    responsibles: z.array(z.string()),
    status: z.array(z.number()),
    taskType: z.array(z.string()),
    includeMetadata: z.boolean(),
    tags: z.array(z.string()),
  })
  .partial();

export type ITaskCostsEndpointParameters = z.infer<
  typeof TTaskCostsEndpointParameters
>;
export const TTaskCostsEndpointParameters = TTasksEndpointParameters.extend({
  costType: z.union([z.literal("cost"), z.literal("timeEntry")]),
  endDate: z.string(),
  startDate: z.string(),
  taskIDs: z.array(z.string()),
  ongoing: z.boolean(),
}).partial();
